import type { SimpleActiveFilter } from 'autogen/swagger/all';
import FilterTag from 'components/Filter/components/FilterTag/FilterTag';
import useFilters from '../../../shared/hooks/useFilters';

export default function SimpleActiveFilterOption({
    model: { displayValue, queryStringName, value }
}: {
    model: SimpleActiveFilter;
}) {
    const { removeFilterByValue } = useFilters();

    return <FilterTag onClick={() => removeFilterByValue(queryStringName, value)}>{displayValue}</FilterTag>;
}
